import { HttpClient } from '@angular/common/http';
import { SwPush } from '@angular/service-worker';
import { ServiceNotification } from './notification.service';
import { MockServiceNotification } from './notification.service.mock';
import { AppConfig } from '../../app-services/config/config.app';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { Enums } from '../../enums/enums';
import { AppSnackBar } from '../../app-services/snackbar/snackbar.app';
import { AbstractServiceAzureStorage } from '../azure-storage.service.ts/azure-storage.service.abstract';

export function FactoryServiceNotification(
    http: HttpClient,
    endpoints: AbstractEndpoints,
    appConfig: AppConfig,
    appMonitoring: AppMonitoring,
    swPush: SwPush,
    appSnackbar: AppSnackBar,
    serviceStorage: AbstractServiceAzureStorage
) {
    appMonitoring.logEvent('FactoryServiceNotification', 'Notification Service Factory loaded');
    switch (appConfig.environment) {
        case Enums.Environments.MockData:
        case Enums.Environments.MockDataWithAuth:
            return new MockServiceNotification(appConfig, swPush, appMonitoring);
        default:
            return new ServiceNotification(http, endpoints, appConfig, appMonitoring, swPush, appSnackbar, serviceStorage);
    }
}